import React, { useEffect } from "react";
// Prime React
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

import "./global.scss";
import "./common.scss";
import "./style.scss";
import "./arabic.scss";
import "./animation.scss";

import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "routes";
import { AuthMiddleware, PublicRoute } from "routes/route";
import { useSelector } from "react-redux";
import Toast from "components/common/Toast";
import Cookies from "js-cookie";
import i18n from "config/i18n";
import GlobalDeleteModal from "components/common/GlobalDeleteModal";
import ScrollToTop from "components/common/ScrollToTop";

function App() {
  const { isVisible, text, type } = useSelector((state) => state.Alert);

  useEffect(() => {
    let lang = Cookies.get("I18N_LANGUAGE") || "en";

    i18n.changeLanguage(lang);

    const htmlEl = document.documentElement;
    if (lang === "ar") {
      htmlEl.setAttribute("dir", "rtl");
      htmlEl.setAttribute("id", "rtl");
    } else {
      htmlEl.setAttribute("dir", "ltr");
      htmlEl.setAttribute("id", "ltr");
    }
  }, []);

  return (
    <React.Fragment>
      {isVisible && <Toast isVisible={isVisible} text={text} type={type} />}
      <GlobalDeleteModal />
      <ScrollToTop />
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<PublicRoute>{route.element}</PublicRoute>}
            key={idx}
          />
        ))}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<AuthMiddleware>{route.element}</AuthMiddleware>}
            key={idx}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
}

export default App;
